module.exports = __webpack_public_path__ + "img/logo.055c8407.png";